
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

const NoOfferBell = () => import('@/components/buybox/NoOfferBell.vue');

import OfferReporter from '@/components/buybox/OfferReporter.vue';
import UpcomingBox from '@/components/upcoming/UpcomingBox.vue';

import TitleWatchlistMutationMixin from '@/mixins/title-quick-action-mutations/TitleWatchlistMutationMixin.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';

@Component({
	name: 'UpcomingContent',
	components: {
		UpcomingBox,
		NoOfferBell,
		OfferReporter,
	},
})
export default class UpcomingContent extends Mixins(TitleWatchlistMutationMixin) {
	/** When title is a Season or Episode, we need a reference to the parent Show. */
	@Prop({ required: true }) parentTitle: TitleDetail;
	@Prop({ required: true }) title: TitleDetail;
	@Prop({ default: true }) isTitleInWatchlist: boolean;

	get upcomingReleases() {
		return this.title.content.upcomingReleases;
	}

	get titleDetails() {
		return {
			title: this.title.content.title ?? this.parentTitle.content.title,
			objectType: this.title.objectType ?? this.parentTitle.objectType,
			objectId: this.title.objectId ?? this.parentTitle.objectId,
		} as const;
	}

	@Watch('isLoggedIn', { immediate: true })
	onIsLoggedInChange() {
		if (!this.isLoggedIn()) return;

		this.mixin_onIsLoggedInChange(this.parentTitle.id, this.titleDetails, this.isTitleInWatchlist, 'upcomingbox');
	}

	onNotifyMe() {
		this.mixin_setInWatchlist(this.parentTitle.id, this.isTitleInWatchlist, this.titleDetails, {
			source: 'upcomingbox',
		});
	}
}
